import { css } from 'styled-components';
import { PINK, PURPLE_TEXT, GREY_EXPERIENCE_TITLE } from '../../../constants/colors';
import { rem, media } from '../../../helpers/mixins';

export default {
  datetext: css`
  color: ${PINK};
  font-size: ${rem('12px')};
  margin-bottom: 30px;
  padding-left:26px;
  padding-right:26px;
  ${media.md`
    margin-bottom: 40px;
    padding-left:0px;
    padding-right:0px;
  `};
  `,
  extratools: css`
  margin-top:15px;
  padding-left:26px;
  padding-right:26px;
  ${media.md`
    margin-top:20px;
    padding-left:0px;
    padding-right:0px;
  `};
  `,
  back: css`
  cursor: pointer;
  display:inline-block;
  padding:6px 20px;
  ${media.md`
    padding:6px 25px;
  `};
  border-radius:4px;
  border: 1px solid ${PINK};
  font-size: ${rem('14px')};
  color:${PINK} !important;
  `,
  maintitle: css`
  margin-bottom: 10px;
  font-size: ${rem('22px')};
  color: ${PURPLE_TEXT};
  padding-left:26px;
  padding-right:26px;
  ${media.sm`
    font-size: ${rem('24px')};
  `};
  ${media.md`
    margin-bottom: 20px;
    padding-left:0px;
    padding-right:0px;
    font-size: ${rem('34px')};
  `};
  `,
  container: css`
      margin-top: 40px;
      margin-bottom:60px;
    ${media.sm`
      margin-top: 60px;
      margin-bottom:60px;
    `};
    ${media.md`
      margin-top: 90px;
      margin-bottom:90px;
    `};
    width: auto;
  `,
  review: css`
    padding-left:26px;
    padding-right:26px;
    font-size: ${rem('16px')};
    margin-top:30px;
    margin-bottom:30px;
    ${media.sm`
      margin-top:40px;
      margin-bottom:40px;
      font-size: ${rem('18px')};
    `};
    ${media.md`
      padding-left:0px;
      padding-right:0px;
      margin-top:50px;
      margin-bottom:50px;
      font-size: ${rem('22px')};
    `};
    color:${GREY_EXPERIENCE_TITLE};

  `,
  content: css`
    padding-left:26px;
    padding-right:26px;
    ${media.md`
      padding-left:0px;
      padding-right:0px;
    `};
    font-size: ${rem('14px')};
   line-height:24px;
    a {
      color: ${PINK};
    }
  `,
  image: css`
    & img{
      border-radius: 12px;
    }

  `
};
